import { fetchApi } from '@/config/axiosSetting';
import {
  GetCulpritCustomerAttachedDocumentImagesQueryParamsType,
  GetCulpritCustomerAttachedDocumentImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerAttachedDocumentImages/getCulpritCustomerAttachedDocumentImagesQuery.type';

export const getCulpritCustomerAttachedDocumentImagesFunction = (
  params: GetCulpritCustomerAttachedDocumentImagesQueryParamsType,
): Promise<GetCulpritCustomerAttachedDocumentImagesQueryResponseType[]> => {
  return fetchApi.get(
    `property/reports/${params.id}/accident_users/culprit/customer/images/additional/document/`,
  );
};
